import React from 'react';
import { injectIntl } from 'react-intl-next';
import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';
import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import { type Props } from './types';
import messages from './messages';
import connectSpaceEmptyStateIcon from '../../icons/file-cabinet.svg';
import mountTrackerFactory from '../../../../common/analytics/mount-tracker-factory';
const MountTracker = mountTrackerFactory('connectSpaceEmptyState');

const CanConnect = ({ intl: { formatMessage }, showConnectSpaceDialog }: Props) => {
	const handleConfirmClick = (_: any, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'connectSpaceButton');
		showConnectSpaceDialog();
	};

	return (
		<div>
			<EmptyState
				width="wide"
				imageUrl={connectSpaceEmptyStateIcon}
				maxImageWidth={101}
				header={formatMessage(messages.granularPagesConnectSpaceHeading)}
				primaryAction={
					<Button onClick={handleConfirmClick}>
						{formatMessage(messages.granularPagesConnectSpaceButton)}
					</Button>
				}
			/>
			<MountTracker />
		</div>
	);
};

export default injectIntl(CanConnect);
